export default __webpack_public_path__ + "locales/ro/InfoPanel.json?hash=466dcff3aa502731ac05d78a8a548b17";